import { initializeApp } from 'firebase/app'
import { getDatabase, ref, update } from 'firebase/database'
import { getStorage } from 'firebase/storage'
import { tenantPath } from './tenant.js'

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
}

if (!config.databaseURL) {
  // eslint-disable-next-line no-console
  console.warn(
    '[firebase] VITE_FIREBASE_DATABASE_URL missing. Copy .env.example to .env.local and fill it in.',
  )
}

export const app = initializeApp(config)
export const db = getDatabase(app)
export const storage = getStorage(app)

// Tenant-aware database ref. Drop-in for `ref(db, path)` — on Golf Elite it
// rewrites the path under the active club's /clubs/{clubId}/ root; on every
// other build tenantPath is identity, so tref(path) === ref(db, path) exactly.
// Re-path club data through this instead of ref(db, …).
export function tref(path) { return ref(db, tenantPath(path)) }

// Tenant-aware KEY for multi-path update() objects (update(ref(db), { [tkey(p)]: v })).
export { tenantPath as tkey }

// Re-key a multi-path update object under the active tenant root (identity off
// Golf Elite). Use with updateTenant(obj) in place of update(ref(db), obj).
export function tenantKeys(obj) {
  if (!obj || typeof obj !== 'object') return obj
  const out = {}
  for (const k of Object.keys(obj)) out[tenantPath(k)] = obj[k]
  return out
}
export function updateTenant(obj) { return update(ref(db), tenantKeys(obj)) }
